export const inputgroup = {
  root: {
    class: ['tw-group/input-group', 'tw-flex tw-items-stretch', 'tw-w-full'],
  },
};
